<template>
  <div class="container ny_content">
    <div class="ny_nav">
      <div class="ny_nav_h">
        <div>
          <h2>关于我们</h2>
          <p>ABOUT US</p>
        </div>
      </div>
      <div class="ny_nav_dqwz">
        当前位置：<span class="hidden-xs">关于我们></span>我的团队
      </div>
    </div>
    <div class="ny_view">
      <div id="ny_img_lists">
        <div class="row" >
          <div class="col-md-4 col-sm-6 col-xs-12 ny_imgs_view" v-for="(item,index) in listData" :key="index">
            <div class="ny_imgs_view_bg"  :style="{background: 'url('+item.url.url+') no-repeat center 50%/cover'}">
<!--              <img src="img/news.jpg" class="ny_img_view" alt="职业测评人">-->
            </div>
            <h3>{{item.title}}</h3>
          </div>


        </div>
      </div>

      <div id="ny_news_page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[6, 8, 10, 12,14]"
          :page-size="queryInfo.limit"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'index',
  data () {
    return {
      queryInfo: {
        column_id:15,
        limit: 6,
        page: 1
      },
      total:0,
      listData:[],
    }
  },
  computed: {
    ...mapState({
      b_data: state =>state.setNavData
    })
  },
  created () {
    // this.queryInfo.column_id = this.b_data
    this.getPhotoList()
  },
  methods: {
    async getPhotoList () {
      const {data: res} = await this.$http.get('home/photo_list', {params:this.queryInfo})
      if (res.code !== 200) return false
      this.listData = res.data.list
      this.total = res.data.totalCount
    },
    handleSizeChange (newSize) {
      this.queryInfo.limit = newSize
      this.getPhotoList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.page = newPage
      this.getPhotoList()
    }
  },
  watch: {
    // b_data (newVal, oldVal) {
    //   this.$set(this.queryInfo, 'column_id', newVal)
    //   this.getPhotoList()
    // }
  },
}
</script>

<style>
/*带背景的分页按钮背景色begin*/
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #C4181F;
  color: #FFF;
}
.el-pagination.is-background .el-pager li.active {
  color: #fff;
  cursor: default;
}
.el-pagination.is-background .el-pager li:hover {
  color: #C4181F;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #C4181F;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #C4181F;
  color: #FFF;
}
li.el-select-dropdown__item.selected {
  color: #C4181F;
}

/*设置当前页码的样式，及鼠标移上其他页码时的样式,以及左右箭头鼠标移上的样式*/

.el-select .el-input.is-focus .el-input__inner,
.el-pagination__sizes .el-input .el-input__inner:hover,
.el-select .el-input__inner:focus {
  border-color: #C4181F;
}
.el-pager li.active,.el-pager li:hover,
.el-pagination button:hover {
  color: #C4181F;
}
/*带背景的分页按钮背景色end*/
</style>



// WEBPACK FOOTER //
// src/views/about/team/index.vue